jQuery(function($) {
  // Funzione per verificare se il dispositivo è desktop
  function isDesktop() {
    return window.innerWidth > 1024;
  }

  // Funzione per gestire l'animazione
  function handleButtonAnimation(e) {
    var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
    $(this).find('.circle-bg').css({top:relY, left:relX});
  }

  function toggleCircleBg() {
    $('.button-v1 .circle-bg').toggle(isDesktop());
  }

  // Applica gli event listener e mostra/nascondi .circle-bg
  function updateButtonBehavior() {
    if (isDesktop()) {
      $('.button-v1')
        .on('mouseenter', handleButtonAnimation)
        .on('mouseout', handleButtonAnimation);
    } else {
      $('.button-v1')
        .off('mouseenter', handleButtonAnimation)
        .off('mouseout', handleButtonAnimation);
    }
    toggleCircleBg();
  }

  // Inizializza
  updateButtonBehavior();

  // Gestisce il ridimensionamento della finestra
  $(window).on('resize', updateButtonBehavior);
});
